<template>
  <section class="section">
    <b-breadcrumb
      :items="[
        { text: this.customerName, to: '/' },
        { text: 'Siti', to: '/sites' },
        { text: siteName, href: '#', active: true },
      ]"
    >
    </b-breadcrumb>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <!-- Canali -->
            <b-tab title="Canali" v-if="guid" active>
              <b-card-text>
                <b-card>
                  <div class="card-block">
                    <div class="row channels">
                      <div class="col-md-12">
                        <div class="form-group">
                          <div style="position: relative" :class="cyState">
                            <div class="absolute flex flex-row filters">
                              <div class="top-select mr-2">
                                <v-select
                                  :clearable="false"
                                  :options="modelOptions"
                                  :reduce="(item) => item.id"
                                  label="name"
                                  value="id"
                                  placeholder="Cerca per modello"
                                  v-model="currentDataModelId"
                                />
                              </div>
                              <div class="top-select-name mr-2">
                                <v-select
                                  clearable
                                  :options="searchChannelOptions"
                                  :filter-by="lineeFilter"
                                  placeholder="Cerca per nome o codice"
                                  v-model="selectedChannel"
                                  @input="zoom()"
                                />
                              </div>
                              <div class="top-select">
                                <v-select
                                  clearable
                                  :options="vectorOptions"
                                  :filter-by="
                                    (option, label, search) => {
                                      return label.toLowerCase().indexOf(search.toLowerCase()) > -1;
                                    }
                                  "
                                  label="text"
                                  :reduce="(o) => o.value"
                                  placeholder="Filtra per Vettore"
                                  v-model="selectedVector"
                                  @input="drawTree"
                                />
                              </div>
                            </div>
                            <div class="px-1">
                              <font-awesome-icon icon="expand" id="expand" @click="expand()" />
                              <font-awesome-icon icon="compress" id="compress" @click="compress()" />
                              <div id="cy" ref="cy"></div>
                            </div>
                          </div>
                          <b-btn variant="secondary" @click="resetZoom">Reset zoom</b-btn>
                          <b-btn
                            variant="warning"
                            v-b-modal.modalAddChannel
                            @click="addNewChannel"
                            :disabled="modelOptions.length < 1"
                          >
                            <font-awesome-icon icon="plus" />Nuovo canale
                          </b-btn>
                          <b-btn variant="primary" @click="openBulkModal()">Operazioni bulk</b-btn>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-4 mb-4">
                      <div class="col">
                        <vue-good-table
                          @on-selected-rows-change="selectedRowsChange"
                          :columns="columns"
                          :rows="rows"
                          :select-options="{ enabled: true }"
                          :search-options="{ enabled: true }"
                          :pagination-options="{
                            enabled: true,
                            position: 'bottom',
                            perPageDropdown: [20, 50, 100],
                            dropdownAllowAll: true,
                            setCurrentPage: 1,
                            jumpFirstOrLast: true,
                            firstLabel: 'Prima pagina',
                            lastLabel: 'Ultima pagina',
                            nextLabel: 'Successiva',
                            prevLabel: 'Precedente',
                            rowsPerPageLabel: 'Canali per pagina',
                            ofLabel: 'of',
                            pageLabel: 'page', // for 'pages' mode
                            allLabel: 'tutti',
                          }"
                        >
                          <template #table-row="props">
                            <span v-if="props.column.field == 'data.data_model_id'">
                              {{ customizeDataModel(props.row) }}
                            </span>
                            <span v-else-if="props.column.field == 'data.vector'">
                              {{ customizeVector(props.row) }}
                            </span>
                            <span v-else-if="props.column.field == 'data.visible'">
                              <font-awesome-icon v-if="props.row.data.visible" icon="check" style="color: green" />
                              <font-awesome-icon v-else icon="times" style="color: red" />
                            </span>
                            <span v-else-if="props.column.field == 'data.measured'">
                              <font-awesome-icon v-if="props.row.data.measured" icon="check" style="color: green" />
                              <font-awesome-icon v-else icon="times" style="color: red" />
                            </span>
                            <span v-else-if="props.column.field == 'data.formula'">
                              {{ customizeFormula(props.row) }}
                            </span>
                            <span v-else-if="props.column.field == 'actions'" class="d-flex justify-content-end">
                              <b-btn class="change-button mr-2" @click="openSwitchSiteAndDatamodelModal(props.row)"
                                ><font-awesome-icon icon="angle-double-right"
                              /></b-btn>
                              <b-btn class="change-button mr-2" @click="openEditModal(props.row)"
                                ><font-awesome-icon icon="cogs"
                              /></b-btn>
                              <b-btn variant="danger" @click="openDeleteModal(props.row)"
                                ><font-awesome-icon icon="fa-times"
                              /></b-btn>
                            </span>
                            <span v-else>
                              {{ props.formattedRow[props.column.field] }}
                            </span>
                          </template>
                          <template #table-column="props">
                            {{ props.column.label }}
                          </template>
                        </vue-good-table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label class="contorl-label">Username E-distribuzione</label>
                          <input class="form-control" v-model.trim="form.enelUsername" />
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label class="control-label">Password E-distribuzione</label>
                          <input class="form-control" v-model.trim="form.enelPassword" />
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group">
                          <label class="control-label">POD E-distribuzione</label>
                          <textarea class="form-control" v-model.trim="form.enelPods"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="control-label">Ignora codici esterni</label>
                          <textarea class="form-control" v-model="ignoreExternalFields"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </b-card-text>
              <div class="row">
                <div class="col right">
                  <router-link to="/sites" class="btn btn-secondary">Annulla</router-link>
                  <b-btn variant="danger" v-b-modal.modalDelete>Elimina</b-btn>
                  <input type="submit" class="btn btn-success" v-on:click="submit()" value="Salva" />
                </div>
              </div>
            </b-tab>

            <!-- Indicatori e parametri -->
            <b-tab title="Indicatori e parametri" v-if="form.guid">
              <b-card-text>
                <b-card>
                  <div class="card-block">
                    <b-row class="mb-5">
                      <b-col>
                        <label>Costi vettori energetici</label>

                        <b-list-group>
                          <b-list-group-item variant="light" v-for="(item, idx) in form.vectorCosts" :key="item.vector">
                            <b-row>
                              <b-col>
                                <b-select v-model="form.vectorCosts[idx].vector" :options="vectorOptions"></b-select>
                              </b-col>
                              <b-col>
                                <b-input v-model="form.vectorCosts[idx].cost" placeholder="Costo" />
                              </b-col>
                              <b-col sm="1">
                                <b-button @click="removeCost(idx)">
                                  <font-awesome-icon icon="times" />
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-list-group-item>
                          <b-list-group-item>
                            <b-btn variant="primary" @click="addVectorCost()">
                              <font-awesome-icon icon="plus" /> Aggiungi vettore
                            </b-btn>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-row>

                    <b-row class="mb-5">
                      <b-col>
                        <label>Indicatori</label>

                        <b-list-group>
                          <b-list-group-item variant="light" v-for="(item, idx) in form.indicators" :key="idx">
                            <b-row>
                              <b-col>
                                <b-form-group label="Indicatore">
                                  <b-select
                                    v-model="form.indicators[idx].formulaId"
                                    :options="indicatorsOptions"
                                    required
                                  ></b-select>
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group
                                  label="Numeratore"
                                  description="Codice del canale o del parametro, senza graffe"
                                >
                                  <b-input
                                    type="text"
                                    placeholder=""
                                    v-model="form.indicators[idx].numerator"
                                    required
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group
                                  label="Denominatore"
                                  description="Codice del canale o del parametro, senza graffe"
                                >
                                  <b-input
                                    type="text"
                                    placeholder=""
                                    v-model="form.indicators[idx].denominator"
                                    required
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col sm="1">
                                <b-button class="remove-indicator" @click="removeIndicator(idx)">
                                  <font-awesome-icon icon="times" />
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-list-group-item>
                          <b-list-group-item>
                            <b-btn variant="primary" @click="addIndicator()">
                              <font-awesome-icon icon="plus" /> Aggiungi indicatore
                            </b-btn>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-row>

                    <b-row class="mb-4">
                      <b-col>
                        <label>Parametri</label>
                        <b-list-group>
                          <b-list-group-item class="parameters-list" v-if="parametersTree.length">
                            <div v-for="(parent, indexP) in parametersTree" :key="indexP">
                              <div class="parameter-cnt">
                                <div class="parameter-info">
                                  <span class="parameter-badge">{{ parent.name }}</span>
                                  <span class="parameter-badge code">{{ parent.code }}</span>
                                  <span class="parameter-badge mu">{{ parent.mu }}</span>
                                </div>
                                <font-awesome-icon
                                  class="update-icon"
                                  icon="cogs"
                                  @click="openEditParameterModal(parent)"
                                />
                              </div>
                              <ParameterTreeNode :data="parent" @open-edit-parameter-modal="openEditParameterModal" />
                            </div>
                          </b-list-group-item>

                          <b-list-group-item>
                            <b-btn variant="primary" @click="addSiteParameter()">
                              <font-awesome-icon icon="plus" /> Aggiungi parametro
                            </b-btn>
                          </b-list-group-item>
                        </b-list-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </b-card-text>
              <div class="row">
                <div class="col right">
                  <router-link to="/sites" class="btn btn-secondary">Annulla</router-link>
                  <b-btn variant="danger" v-b-modal.modalDelete>Elimina</b-btn>
                  <input type="submit" class="btn btn-success" v-on:click="submit()" value="Salva" />
                </div>
              </div>
            </b-tab>

            <!-- Anagrafica -->
            <b-tab title="Anagrafica">
              <b-card-text>
                <form
                  role="form"
                  ref="form"
                  class="needs-validation col col-xs-12 centered-col"
                  novalidate
                  @submit.prevent="handleSubmit"
                >
                  <b-card v-if="!isDemo">
                    <div class="card-block">
                      <div class="form-group">
                        <label class="control-label">Nome sito</label>
                        <input required type="text" class="form-control" v-model.trim="form.name" />
                      </div>

                      <div class="row">
                        <div class="col col-md-6">
                          <div class="form-group">
                            <label class="control-label">Nome referente</label>
                            <input required type="text" class="form-control" v-model.trim="form.firstName" />
                          </div>
                        </div>
                        <div class="col col-md-6">
                          <div class="form-group">
                            <label class="control-label">Cognome referente</label>
                            <input required type="text" class="form-control" v-model.trim="form.lastName" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col col-md-6">
                          <div class="form-group">
                            <label class="control-label">Telefono</label>
                            <input required type="text" class="form-control" v-model.trim="form.phone" />
                          </div>
                        </div>
                        <div class="col col-md-6">
                          <div class="form-group">
                            <label class="control-label">E-mail</label>
                            <input required type="email" class="form-control" v-model.trim="form.email" />
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-5">
                          <div class="form-group">
                            <label class="control-label">Cerca indirizzo o azienda</label>
                            <gmap-autocomplete
                              class="form-control"
                              placeholder="Address"
                              @place_changed="setPlace"
                              :options="autocompleteOptions"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="control-label">Nazione</label>
                            <select class="form-control" v-model="form.addressCountry">
                              <option required value="AF">Afghanistan</option>
                              <option value="AL">Albania</option>
                              <option value="DZ">Algeria</option>
                              <option value="UM">Altre isole americane del Pacifico</option>
                              <option value="AD">Andorra</option>
                              <option value="AO">Angola</option>
                              <option value="AI">Anguilla</option>
                              <option value="AQ">Antartide</option>
                              <option value="AG">Antigua e Barbuda</option>
                              <option value="SA">Arabia Saudita</option>
                              <option value="AR">Argentina</option>
                              <option value="AM">Armenia</option>
                              <option value="AW">Aruba</option>
                              <option value="AU">Australia</option>
                              <option value="AT">Austria</option>
                              <option value="AZ">Azerbaigian</option>
                              <option value="BS">Bahamas</option>
                              <option value="BH">Bahrein</option>
                              <option value="BD">Bangladesh</option>
                              <option value="BB">Barbados</option>
                              <option value="BE">Belgio</option>
                              <option value="BZ">Belize</option>
                              <option value="BJ">Benin</option>
                              <option value="BM">Bermuda</option>
                              <option value="BT">Bhutan</option>
                              <option value="BY">Bielorussia</option>
                              <option value="BO">Bolivia</option>
                              <option value="BA">Bosnia ed Erzegovina</option>
                              <option value="BW">Botswana</option>
                              <option value="BR">Brasile</option>
                              <option value="BN">Brunei</option>
                              <option value="BG">Bulgaria</option>
                              <option value="BF">Burkina Faso</option>
                              <option value="BI">Burundi</option>
                              <option value="KH">Cambogia</option>
                              <option value="CM">Camerun</option>
                              <option value="CA">Canada</option>
                              <option value="CV">Capo Verde</option>
                              <option value="BQ">Caraibi olandesi</option>
                              <option value="CZ">C&egrave;chia</option>
                              <option value="EA">Ceuta e Melilla</option>
                              <option value="TD">Ciad</option>
                              <option value="CL">Cile</option>
                              <option value="CN">Cina</option>
                              <option value="CY">Cipro</option>
                              <option value="VA">Citt&agrave; del Vaticano</option>
                              <option value="CO">Colombia</option>
                              <option value="KM">Comore</option>
                              <option value="CD">Congo - Kinshasa</option>
                              <option value="CG">Congo-Brazzaville</option>
                              <option value="KP">Corea del Nord</option>
                              <option value="KR">Corea del Sud</option>
                              <option value="CI">Costa d&rsquo;Avorio</option>
                              <option value="CR">Costa Rica</option>
                              <option value="HR">Croazia</option>
                              <option value="CU">Cuba</option>
                              <option value="CW">Cura&ccedil;ao</option>
                              <option value="DK">Danimarca</option>
                              <option value="DG">Diego Garcia</option>
                              <option value="DM">Dominica</option>
                              <option value="EC">Ecuador</option>
                              <option value="EG">Egitto</option>
                              <option value="SV">El Salvador</option>
                              <option value="AE">Emirati Arabi Uniti</option>
                              <option value="ER">Eritrea</option>
                              <option value="EE">Estonia</option>
                              <option value="ET">Etiopia</option>
                              <option value="EZ">Eurozone</option>
                              <option value="FJ">Figi</option>
                              <option value="PH">Filippine</option>
                              <option value="FI">Finlandia</option>
                              <option value="FR">Francia</option>
                              <option value="GA">Gabon</option>
                              <option value="GM">Gambia</option>
                              <option value="GE">Georgia</option>
                              <option value="GS">Georgia del Sud e Sandwich australi</option>
                              <option value="DE">Germania</option>
                              <option value="GH">Ghana</option>
                              <option value="JM">Giamaica</option>
                              <option value="JP">Giappone</option>
                              <option value="GI">Gibilterra</option>
                              <option value="DJ">Gibuti</option>
                              <option value="JO">Giordania</option>
                              <option value="GR">Grecia</option>
                              <option value="GD">Grenada</option>
                              <option value="GL">Groenlandia</option>
                              <option value="GP">Guadalupa</option>
                              <option value="GU">Guam</option>
                              <option value="GT">Guatemala</option>
                              <option value="GG">Guernsey</option>
                              <option value="GN">Guinea</option>
                              <option value="GQ">Guinea Equatoriale</option>
                              <option value="GW">Guinea-Bissau</option>
                              <option value="GY">Guyana</option>
                              <option value="GF">Guyana francese</option>
                              <option value="HT">Haiti</option>
                              <option value="HN">Honduras</option>
                              <option value="IN">India</option>
                              <option value="ID">Indonesia</option>
                              <option value="IR">Iran</option>
                              <option value="IQ">Iraq</option>
                              <option value="IE">Irlanda</option>
                              <option value="IS">Islanda</option>
                              <option value="AC">Isola Ascensione</option>
                              <option value="CX">Isola Christmas</option>
                              <option value="IM">Isola di Man</option>
                              <option value="NF">Isola Norfolk</option>
                              <option value="AX">Isole &Aring;land</option>
                              <option value="IC">Isole Canarie</option>
                              <option value="KY">Isole Cayman</option>
                              <option value="CC">Isole Cocos (Keeling)</option>
                              <option value="CK">Isole Cook</option>
                              <option value="FO">Isole F&aelig;r &Oslash;er</option>
                              <option value="FK">Isole Falkland</option>
                              <option value="MP">Isole Marianne settentrionali</option>
                              <option value="MH">Isole Marshall</option>
                              <option value="PN">Isole Pitcairn</option>
                              <option value="SB">Isole Salomone</option>
                              <option value="TC">Isole Turks e Caicos</option>
                              <option value="VI">Isole Vergini Americane</option>
                              <option value="VG">Isole Vergini Britanniche</option>
                              <option value="IL">Israele</option>
                              <option value="IT" selected>Italia</option>
                              <option value="JE">Jersey</option>
                              <option value="KZ">Kazakistan</option>
                              <option value="KE">Kenya</option>
                              <option value="KG">Kirghizistan</option>
                              <option value="KI">Kiribati</option>
                              <option value="XK">Kosovo</option>
                              <option value="KW">Kuwait</option>
                              <option value="LA">Laos</option>
                              <option value="LS">Lesotho</option>
                              <option value="LV">Lettonia</option>
                              <option value="LB">Libano</option>
                              <option value="LR">Liberia</option>
                              <option value="LY">Libia</option>
                              <option value="LI">Liechtenstein</option>
                              <option value="LT">Lituania</option>
                              <option value="LU">Lussemburgo</option>
                              <option value="MG">Madagascar</option>
                              <option value="MW">Malawi</option>
                              <option value="MY">Malaysia</option>
                              <option value="MV">Maldive</option>
                              <option value="ML">Mali</option>
                              <option value="MT">Malta</option>
                              <option value="MA">Marocco</option>
                              <option value="MQ">Martinica</option>
                              <option value="MR">Mauritania</option>
                              <option value="MU">Mauritius</option>
                              <option value="YT">Mayotte</option>
                              <option value="MX">Messico</option>
                              <option value="FM">Micronesia</option>
                              <option value="MD">Moldavia</option>
                              <option value="MC">Monaco</option>
                              <option value="MN">Mongolia</option>
                              <option value="ME">Montenegro</option>
                              <option value="MS">Montserrat</option>
                              <option value="MZ">Mozambico</option>
                              <option value="MM">Myanmar (Birmania)</option>
                              <option value="NA">Namibia</option>
                              <option value="NR">Nauru</option>
                              <option value="UN">nazioni unite</option>
                              <option value="NP">Nepal</option>
                              <option value="NI">Nicaragua</option>
                              <option value="NE">Niger</option>
                              <option value="NG">Nigeria</option>
                              <option value="NU">Niue</option>
                              <option value="NO">Norvegia</option>
                              <option value="NC">Nuova Caledonia</option>
                              <option value="NZ">Nuova Zelanda</option>
                              <option value="OM">Oman</option>
                              <option value="NL">Paesi Bassi</option>
                              <option value="PK">Pakistan</option>
                              <option value="PW">Palau</option>
                              <option value="PA">Panam&aacute;</option>
                              <option value="PG">Papua Nuova Guinea</option>
                              <option value="PY">Paraguay</option>
                              <option value="PE">Per&ugrave;</option>
                              <option value="PF">Pochannelsia francese</option>
                              <option value="PL">Polonia</option>
                              <option value="PT">Portogallo</option>
                              <option value="PR">Portorico</option>
                              <option value="QA">Qatar</option>
                              <option value="HK">RAS di Hong Kong</option>
                              <option value="MO">RAS di Macao</option>
                              <option value="GB">Regno Unito</option>
                              <option value="CF">Repubblica Centrafricana</option>
                              <option value="MK">Repubblica di Macedonia</option>
                              <option value="DO">Repubblica Dominicana</option>
                              <option value="RE">Riunione</option>
                              <option value="RO">Romania</option>
                              <option value="RW">Ruanda</option>
                              <option value="RU">Russia</option>
                              <option value="EH">Sahara occidentale</option>
                              <option value="KN">Saint Kitts e Nevis</option>
                              <option value="LC">Saint Lucia</option>
                              <option value="MF">Saint Martin</option>
                              <option value="PM">Saint Pierre e Miquelon</option>
                              <option value="VC">Saint Vincent e Grenadines</option>
                              <option value="BL">Saint-Barth&eacute;lemy</option>
                              <option value="WS">Samoa</option>
                              <option value="AS">Samoa americane</option>
                              <option value="SM">San Marino</option>
                              <option value="SH">Sant&rsquo;Elena</option>
                              <option value="ST">S&atilde;o Tom&eacute; e Pr&iacute;ncipe</option>
                              <option value="SN">Senegal</option>
                              <option value="RS">Serbia</option>
                              <option value="SC">Seychelles</option>
                              <option value="SL">Sierra Leone</option>
                              <option value="SG">Singapore</option>
                              <option value="SX">Sint Maarten</option>
                              <option value="SY">Siria</option>
                              <option value="SK">Slovacchia</option>
                              <option value="SI">Slovenia</option>
                              <option value="SO">Somalia</option>
                              <option value="ES">Spagna</option>
                              <option value="LK">Sri Lanka</option>
                              <option value="US">Stati Uniti</option>
                              <option value="SS">Sud Sudan</option>
                              <option value="ZA">Sudafrica</option>
                              <option value="SD">Sudan</option>
                              <option value="SR">Suriname</option>
                              <option value="SJ">Svalbard e Jan Mayen</option>
                              <option value="SE">Svezia</option>
                              <option value="CH">Svizzera</option>
                              <option value="SZ">Swaziland</option>
                              <option value="TJ">Tagikistan</option>
                              <option value="TW">Taiwan</option>
                              <option value="TZ">Tanzania</option>
                              <option value="TF">Terre australi francesi</option>
                              <option value="PS">Territori palestinesi</option>
                              <option value="IO">Territorio britannico dell&rsquo;Oceano Indiano</option>
                              <option value="TH">Thailandia</option>
                              <option value="TL">Timor Est</option>
                              <option value="TG">Togo</option>
                              <option value="TK">Tokelau</option>
                              <option value="TO">Tonga</option>
                              <option value="TT">Trinidad e Tobago</option>
                              <option value="TA">Tristan da Cunha</option>
                              <option value="TN">Tunisia</option>
                              <option value="TR">Turchia</option>
                              <option value="TM">Turkmenistan</option>
                              <option value="TV">Tuvalu</option>
                              <option value="UA">Ucraina</option>
                              <option value="UG">Uganda</option>
                              <option value="HU">Ungheria</option>
                              <option value="UY">Uruguay</option>
                              <option value="UZ">Uzbekistan</option>
                              <option value="VU">Vanuatu</option>
                              <option value="VE">Venezuela</option>
                              <option value="VN">Vietnam</option>
                              <option value="WF">Wallis e Futuna</option>
                              <option value="YE">Yemen</option>
                              <option value="ZM">Zambia</option>
                              <option value="ZW">Zimbabwe</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="control-label">Provincia</label>
                            <select v-on:change="loadTowns()" required class="form-control" v-model="form.addressState">
                              <option v-for="state in states" v-bind:key="state.code" :value="state.code">
                                {{ state.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label class="control-label">Città</label>
                            <select required class="form-control" v-model="form.addressTown">
                              <option v-for="town in towns" v-bind:key="town" :value="town">{{ town }}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label class="control-label">CAP</label>
                            <input required type="text" class="form-control" v-model="form.addressZip" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xs-12 col-md-8">
                          <div class="form-group">
                            <label class="control-label">Indirizzo</label>
                            <input required type="text" class="form-control" v-model.trim="form.addressStreetName" />
                          </div>
                        </div>
                        <div class="col-xs-12 col-md-4">
                          <div class="form-group">
                            <label class="control-label">N°</label>
                            <input type="text" class="form-control" v-model.trim="form.addressStreetNumber" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <geocoding :address="composeAddress" v-on:geocoded="updateCoordinates" />
                  </b-card>
                  <div class="row">
                    <div class="col right">
                      <router-link to="/sites" class="btn btn-secondary">Annulla</router-link>
                      <b-btn variant="danger" v-b-modal.modalDelete>Elimina</b-btn>
                      <button type="submit" class="btn btn-success">Salva</button>
                    </div>
                  </div>
                </form>
              </b-card-text>
            </b-tab>

            <!-- Forniture -->
            <b-tab v-if="form.id" title="Forniture">
              <b-card-text>
                <b-card title="Forniture">
                  <supply :siteId="form.id" />
                </b-card>
              </b-card-text>
            </b-tab>

            <!-- Utenze -->
            <b-tab v-if="form.id" title="Utenze">
              <b-card-text>
                <b-card>
                  <Virtual :siteId="siteId" @reload="reloadTree()" />
                </b-card>
              </b-card-text>
            </b-tab>

            <!-- Gestione dati -->
            <b-tab v-if="form.id" title="Gestione dati">
              <b-card-text>
                <b-card title="Elimina dati al minuto, quartorari o orari">
                  <DeleteChannelData :datamodels="modelOptions" :channels="form.channels" />
                </b-card>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <ParameterModal
      :samplingList="samplingList"
      :parameter="parameter"
      :parameters="form.parameters"
      :siteGuid="guid"
      @saved="createParametersTree()"
    />

    <b-modal
      size="lg"
      id="modalBulkChannel"
      ref="modalBulkChannel"
      centered
      title="Operazioni bulk"
      header-bg-variant="warning"
      hide-footer
    >
      <b-row>
        <b-col>
          <span>{{ bulkChannels.length }} canali selezionati</span>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4" class="d-flex align-items-center">
          <b-form-group label="Visibilità">
            <b-select
              v-model="bulk.visible"
              :options="[
                { text: 'Non modificare', value: null },
                { text: 'Visibile', value: 1 },
                { text: 'Non visibile', value: 0 },
              ]"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Canale misurato">
            <b-select
              v-model="bulk.measured"
              :options="[
                { text: 'Non modificare', value: null },
                { text: 'Misurato', value: 1 },
                { text: 'Non misurato', value: 0 },
              ]"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="4">
          <b-form-group label="Soglia alert (ore)">
            <input class="form-control" v-model.trim="bulk.alert_threshold" type="number" />
            <b-form-text>Numero di ore massimo consentito in assenza di dati</b-form-text>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="Granularità minima">
            <b-select v-model="bulk.min_sampling" :options="minSamplingsList"></b-select>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <div class="form-group has-warning">
            <b-form-group id="vector" label="Vettore">
              <b-form-select v-model="bulk.vector" :options="vectorOptions" />
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Assegna albero">
            <v-select
              :clearable="true"
              :options="modelOptions"
              :reduce="(item) => item.id"
              label="name"
              value="id"
              v-model="bulk.data_model_id"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Appendi a canale">
            <v-select clearable :options="searchChannelOptions" :filter-by="lineeFilter" v-model="bulk.parent_code" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="6">
          <b-form-group label="Misure">
            <v-select
              multiple
              v-model="bulk.measure_types"
              :options="measureTypesList"
              :reduce="(measure) => measure.code"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="bulk.measure_types && bulk.measure_types.length > 0" cols="6">
          <b-form-group label="Operazione su misure">
            <v-select
              :clearable="false"
              v-model="bulk.type_operation"
              :options="measureTypeOperationList"
              :reduce="(measure) => measure.value"
              label="label"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="d-flex justify-content-end">
          <b-btn class="mr-2" variant="secondary" @click="closeBulkModal()">Annulla</b-btn>
          <b-btn type="button" variant="primary" @click="submitBulk()">Modifica</b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modalSwitchSiteAndDatamodel"
      ref="modalSwitchSiteAndDatamodel"
      centered
      title="Sposta canale"
      header-bg-variant="success"
      hide-footer
    >
      <b-row>
        <b-col>
          <label class="form-label"
            >Canale selezionato: {{ channelToSwitchSiteAndDatamodel.label }} ({{
              channelToSwitchSiteAndDatamodel.code
            }})</label
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Modifica sito in:</label>
            <v-select
              v-model="siteToCopyIn"
              :selectable="(site) => isSiteAvailable(site)"
              :reduce="(item) => item.guid"
              :options="sitesList"
              label="name"
              @input="filterModelOptions"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="form-group">
            <label class="form-label">Modifica modello in:</label>
            <v-select
              :clearable="false"
              v-model="dataModelToCopyIn"
              :selectable="(model) => isDatamodelAvailable(model)"
              :reduce="(item) => item.id"
              :options="modelOptionsFiltered"
              label="name"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('modalSwitchSiteAndDatamodel')">Annulla</b-btn>
          <b-btn v-if="modelOptionsFiltered.length > 0" type="button" variant="primary" @click="switchSiteAndDataModel"
            >Salva</b-btn
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      size="lg"
      id="modalAddChannel"
      ref="modalAddChannel"
      centered
      title="Nuovo canale"
      header-bg-variant="warning"
      hide-footer
    >
      <form class="needs-validation" ref="form" novalidate @submit.prevent="(e) => preventSubmit(e, 'add')">
        <b-row v-if="modelOptions.length > 1">
          <b-col>
            <div class="form-group">
              <label class="form-label">Copia da modello:</label>
              <v-select
                :clearable="false"
                v-model="copyFromModel"
                :reduce="(item) => item.id"
                :options="modelOptions"
                label="name"
                value="id"
              ></v-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Canale:</label>
              <v-select
                :clearable="false"
                v-model="copyFromChannel"
                :options="copyChannelOptions"
                :disabled="copyFromModel ? false : true"
              ></v-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-label">Nome canale:</label>
              <input class="form-control" v-model.trim="channel.name" type="text" />
            </div>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Codice canale:</label>
              <input class="form-control" v-model.trim="channel.code" type="text" />
              <span class="has-warning">
                Il codice deve iniziare con una lettera<br />
                Caratteri ammessi: alfanumerici e _
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-checkbox
              class="mb-2"
              ref="visibilityCheck"
              v-model="channel.measured"
              :value="1"
              :unchecked-value="0"
            >
              Canale misurato
            </b-form-checkbox>
          </b-col>
          <b-col cols="6">
            {{ channel.is_realtime }}
            <b-form-checkbox
              class="mb-2"
              ref="visibilityCheck"
              v-model="channel.is_realtime"
              :value="1"
              :unchecked-value="0"
            >
              Misure in tempo reale
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <div class="form-group">
              <label class="form-label">Alert assenza dati:</label>
              <input class="form-control" v-model.trim="channel.alert_threshold" type="number" />
              <b-form-text>Numero di ore massimo consentito in assenza di dati</b-form-text>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="form-group">
              <label class="form-label">Alert dati a 0:</label>
              <input class="form-control" v-model.trim="channel.alert_zero_threshold" type="number" />
              <b-form-text>Numero di ore massimo consentito in con dati continui a 0</b-form-text>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group">
              <label class="form-label">Granularità minima:</label>
              <b-select v-model="channel.min_sampling" :options="minSamplingsList" required></b-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-label">Categoria:</label>
              <b-select v-model="channel.category" :options="categories"></b-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <b-form-group id="vector">
                <label class="form-label">Vettore:</label>
                <b-form-select v-model="channel.vector" :options="vectorOptions" required />
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group" v-if="channelsOptions.length">
              <label class="form-label">Appendi a:</label>
              <v-select
                v-model="parent_code"
                :options="channelsOptions"
                :reduce="(channel) => channel.value"
                label="text"
              />
            </div>
          </b-col>
          <b-col>
            <label class="form-label">Opzioni:</label>
            <div class="d-flex">
              <b-form-checkbox
                class="mr-2"
                id="visible"
                ref="visibilityCheck"
                v-model="channel.visible"
                value="1"
                unchecked-value="0"
              >
                Visibile
              </b-form-checkbox>
              <b-form-checkbox class="mx-2" id="is_root" v-model="channel.is_root" value="1" unchecked-value="0">
                Root
              </b-form-checkbox>
              <b-form-checkbox class="ml-2" id="is_virtual" v-model="channel.is_virtual" value="1" unchecked-value="0">
                Utenza
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="channel.is_virtual == 1">
          <b-col>
            <div class="form-group">
              <label class="form-label">Potenza utenza:</label>
              <input class="form-control" v-model.trim="channel.virtual_value" type="number" step=".01" required />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">Canale root:</label>
              <v-select
                v-model="channel.root_channel_code"
                :options="rootChannelOptions"
                :selectable="(data) => data.code != channel.code"
                :reduce="(ch) => ch.code"
                label="name"
                value="code"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Formula:</label>
              <b-select v-model="channel.formula" :disabled="channel.is_virtual == 1">
                <option></option>
                <option value="children-sum">Somma canali figli</option>
                <option value="parent-minus-siblings">Differenza padre-fratelli</option>
                <option value="custom">Formula custom</option>
              </b-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Misure:</label>
              <v-select
                multiple
                v-model="channel.measure_types"
                :options="measureTypesList"
                :reduce="(measure) => measure.code"
                label="name"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-if="channel.formula == 'custom' && channel.is_virtual != 1">
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Formula custom:</label>
              <b-input type="text" v-model="channel.custom_formula" />

              <span class="has-warning">I codici dei canali devono essere racchiusi da graffe, es: {POD001}</span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group description="Inserire un codice per riga">
              <label class="form-label">Codici esterni:</label>
              <b-form-textarea v-model="channel.external_codes_string"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-checkbox class="ml-2" v-model="channel.is_supply" value="1" unchecked-value="0">
              Punto di fornitura
            </b-form-checkbox>
            <b-form-checkbox class="ml-2" v-model="channel.is_self_production" value="1" unchecked-value="0">
              Punto auto-produzione
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-btn class="mr-2" variant="secondary" @click="resetChannel()">Reset</b-btn>
            <b-btn class="mr-2" variant="secondary" @click="$bvModal.hide('modalAddChannel')">Annulla</b-btn>
            <b-btn type="submit" variant="primary">Aggiungi</b-btn>
          </b-col>
        </b-row>
      </form>

      <b-alert :variant="channelAlertVariant" :show="channelMessageShow">{{ channelMessage }}</b-alert>
    </b-modal>

    <b-modal
      size="lg"
      id="modalEditChannel"
      ref="modalEditChannel"
      centered
      title="Modifica canale"
      header-bg-variant="warning"
      hide-footer
    >
      <form class="needs-validation" ref="form" novalidate @submit.prevent="(e) => preventSubmit(e, 'edit')">
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-label">Nome canale:</label>
              <input class="form-control" v-model.trim="channel.name" type="text" />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">Codice canale:</label>
              <input class="form-control" readonly v-model.trim="channel.code" type="text" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-checkbox
              class="mb-2"
              ref="visibilityCheck"
              v-model="channel.measured"
              :value="1"
              :unchecked-value="0"
            >
              Canale misurato
            </b-form-checkbox>
          </b-col>
          <b-col cols="6">
            <b-form-checkbox
              class="mb-2"
              ref="visibilityCheck"
              v-model="channel.is_realtime"
              :value="1"
              :unchecked-value="0"
            >
              Misure in tempo reale
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <div class="form-group">
              <label class="form-label">Alert assenza dati:</label>
              <input class="form-control" v-model.trim="channel.alert_threshold" type="number" />
              <b-form-text>Numero di ore massimo consentito in assenza di dati</b-form-text>
            </div>
          </b-col>
          <b-col cols="3">
            <div class="form-group">
              <label class="form-label">Alert dati a 0:</label>
              <input class="form-control" v-model.trim="channel.alert_zero_threshold" type="number" />
              <b-form-text>Numero di ore massimo consentito in con dati continui a 0</b-form-text>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group">
              <label class="form-label">Granularità minima:</label>
              <b-select v-model="channel.min_sampling" :options="minSamplingsList" required></b-select>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <label class="form-label">Categoria:</label>
              <b-select v-model="channel.category" :options="categories"></b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <b-form-group id="vector">
                <label class="form-label">Vettore:</label>
                <b-form-select v-model="channel.vector" :options="vectorOptions" />
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group" v-if="channelsOptions.length">
              <label class="form-label">Appendi a:</label>
              <v-select
                v-model="parent_code"
                :options="channelsOptions"
                :selectable="(data) => data.value != channel.code"
                :reduce="(channel) => channel.value"
                label="text"
              />
            </div>
          </b-col>
          <b-col>
            <label class="form-label">Opzioni:</label>
            <div class="d-flex">
              <b-form-checkbox
                class="mr-2"
                id="visible"
                ref="visibilityCheck"
                v-model="channel.visible"
                value="1"
                unchecked-value="0"
              >
                Visibile
              </b-form-checkbox>
              <b-form-checkbox class="mx-2" id="is_root" v-model="channel.is_root" value="1" unchecked-value="0">
                Root
              </b-form-checkbox>
              <b-form-checkbox class="ml-2" id="is_virtual" v-model="channel.is_virtual" value="1" unchecked-value="0">
                Utenza
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="channel.is_virtual == 1">
          <b-col>
            <div class="form-group">
              <label class="form-label">Potenza utenza:</label>
              <input class="form-control" v-model.trim="channel.virtual_value" type="number" step=".01" required />
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-label">Canale root:</label>
              <v-select
                v-model="channel.root_channel_code"
                :options="rootChannelOptions"
                :selectable="(data) => data.code != channel.code"
                :reduce="(ch) => ch.code"
                label="name"
                value="code"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Formula:</label>
              <b-select v-model="channel.formula" :disabled="channel.is_virtual == 1">
                <option></option>
                <option value="children-sum">Somma canali figli</option>
                <option value="parent-minus-siblings">Differenza padre-fratelli</option>
                <option value="custom">Formula custom</option>
              </b-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Misure:</label>
              <v-select
                multiple
                v-model="channel.measure_types"
                :options="measureTypesList"
                :reduce="(measure) => measure.code"
                label="name"
              />
            </div>
          </b-col>
        </b-row>
        <b-row v-if="channel.formula == 'custom' && channel.is_virtual != 1">
          <b-col>
            <div class="form-group has-warning">
              <label class="form-label">Formula custom:</label>
              <b-input type="text" v-model="channel.custom_formula" />
              <span class="has-warning">I codici dei canali devono essere racchiusi da graffe, es: {POD001}</span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group description="Inserire un codice per riga">
              <label class="form-label">Codici esterni:</label>
              <b-form-textarea v-model="channel.external_codes_string"></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-checkbox class="ml-2" v-model="channel.is_supply" value="1" unchecked-value="0">
              Punto di fornitura
            </b-form-checkbox>
            <b-form-checkbox class="ml-2" v-model="channel.is_self_production" value="1" unchecked-value="0">
              Punto auto-produzione
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-end">
            <b-btn class="mr-2" variant="danger" @click="openDeleteModal({ data: channel })">Rimuovi canale</b-btn>
            <b-btn type="submit" variant="primary">Modifica</b-btn>
          </b-col>
        </b-row>
      </form>

      <b-alert :variant="channelAlertVariant" :show="channelMessageShow">{{ channelMessage }}</b-alert>
    </b-modal>

    <b-modal
      id="modalDelete"
      ref="modal"
      centered
      title="Conferma cancellazione"
      header-bg-variant="danger"
      ok-title="Procedi"
      ok-variant="danger"
      @ok="goDelete"
    >
      <p>
        Procedere con la cancellazione del sito <b>{{ this.form.name }}</b
        >? <br /><br />
        <small>I dati verranno comunque mantenuti nel database.</small>
      </p>
    </b-modal>

    <b-modal
      id="modalDeleteChannel"
      ref="modalDeleteChannel"
      centered
      title="Conferma cancellazione"
      header-bg-variant="danger"
      ok-title="Procedi"
      ok-variant="danger"
      @ok="deleteChannel()"
    >
      <p>
        Procedere con la cancellazione del canale
        <b v-if="this.channelToDelete && this.channelToDelete.label">{{ this.channelToDelete.label }}</b
        >?
      </p>
    </b-modal>

    <b-modal
      id="modalDataModel"
      ref="modalDataModel"
      centered
      title="Nessun modello associato al sito"
      header-bg-variant="danger"
      :hide-footer="true"
    >
      <p>
        Per poter aggiungere canali al sito è necessario associare un modello al sito. Utilizzare la funzionalià
        all'interno della pagina di modifica del cliente.
      </p>
      <div class="d-flex justify-content-end">
        <b-btn variant="secondary" @click="$bvModal.hide('modalDataModel')">Annulla</b-btn>
        <router-link :to="`/customers/${customerGuid}/edit`" class="btn btn-primary ml-2">Procedi</router-link>
      </div>
    </b-modal>

    <b-modal
      id="modalConversion"
      ref="modalConversion"
      centered
      title="Fattori di conversione"
      size="lg"
      header-bg-variant="warning"
      ok-title="Ok"
      cancel-title="Annulla"
      @ok="closeConversionModal"
    >
      <table class="table">
        <tr>
          <th>U.M. da:</th>
          <th>U.M. a:</th>
          <th>Fattore di conversione</th>
          <th></th>
        </tr>
        <tr v-for="(item, idx) in conversions" :key="idx">
          <td>
            <b-form-input v-model="item.muFrom" trim />
          </td>
          <td>
            <b-form-input v-model="item.muTo" trim />
          </td>
          <td>
            <b-form-input v-model="item.factor" trim />
          </td>
          <td>
            <b-btn variant="danger" @click="removeConversion(idx)">
              <font-awesome-icon icon="times" />
            </b-btn>
          </td>
        </tr>
      </table>

      <b-row>
        <b-col>
          <b-btn variant="primary" @click="conversions.push({})">
            <font-awesome-icon icon="plus" /> Aggiungi conversione
          </b-btn>
        </b-col>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
import Geocoding from "./Geocoding";
import customerMenu from "../Menu.vue";
import VueTagsInput from "@johmun/vue-tags-input";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Supply from "./Supply";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Virtual from "./Virtual.vue";
import DeleteChannelData from "./DeleteChannelData.vue";
import ParameterTreeNode from "./Parameters/ParameterTreeNode.vue";
import ParameterModal from "./Parameters/ParameterModal.vue";
import { getSamplings } from "../../../helpers/measure";

export default {
  name: "CustomerSite",
  created() {
    this.load();
    this.$store.state.user.sites.forEach((site) => {
      site.channels.forEach((channel) => {
        this.allChannels.push(channel);
      });

      if (site.guid == this.$route.params.guid) {
        this.form.parameters = site.parameters;
      }
    });
    this.createParametersTree();
  },
  props: ["currentPage"],
  components: {
    customerMenu,
    VueTagsInput,
    Geocoding,
    vSelect,
    Supply,
    VueGoodTable,
    Virtual,
    DeleteChannelData,
    ParameterTreeNode,
    ParameterModal,
  },
  mounted() {
    this.samplingList = getSamplings();
    this.initChannels();
    if (this.measureTypesList.length == 0) {
      this.$store.commit("loading");
      this.$store.dispatch("sites/measureTypesList").then((data) => {
        this.measureTypesList = data.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          return -1;
        });
        this.$store.commit("stopLoading");
      });
    }
    this.form.addressCountry = "IT";
  },
  data() {
    return {
      samplingList: [],
      customerGuid: null,
      guid: null,
      selectedChannel: null,
      selectedVector: null,
      parent_code: null,
      autocompleteOptions: {
        componentRestrictions: {
          country: ["it"],
        },
        fields: ["address_components", "geometry"],
      },
      form: {
        channels: [],
        vectorCosts: [],
        indicators: [],
        parameters: [],
        tags: [],
        addressStreetName: null,
        addressStreetNumber: null,
        addressTown: null,
        addressState: null,
        addressZip: null,
        addressCountry: null,
      },
      tag: "",
      siteTags: [],
      siteVectorCosts: [],
      indicatorFormulas: [],
      searchChannelOptions: [],
      copyChannelOptions: [],
      places: [],
      channelsOptions: [],
      currentPlace: null,
      newChannelShown: false,
      channel: {
        visible: 1,
      },
      channelAlertVariant: "",
      channelMessage: "",
      channelMessageShow: false,
      cy: null,
      editChannelOk: "Aggiungi",
      editChannelTitle: "Nuovo canale",
      editingCode: null,
      categories: [
        { value: null, text: "" },
        { value: 1, text: "Attività" },
        { value: 2, text: "Servizi ausiliari" },
        { value: 3, text: "Servizi generali" },
        { value: 4, text: "Altro" },
      ],
      minSamplingsList: [
        { value: "1", text: "1 Minuto" },
        { value: "15", text: "15 Minuti" },
        { value: "60", text: "60 Minuti" },
        { value: "d", text: "Giornaliero" },
        { value: "m", text: "Mensile" },
        { value: "y", text: "Annuale" },
      ],
      conversions: [],
      currentParameter: -1,
      cyState: "min",
      ignoreExternalFields: "",
      currentDataModelId: null,
      modelOptions: [],
      siteId: "",
      copyFromModel: "",
      copyFromChannel: "",
      channelCopy: "",
      columns: [
        {
          label: "Nome",
          field: "data.label",
        },
        {
          label: "Codice",
          field: "data.code",
        },
        {
          label: "Modello",
          field: "data.data_model_id",
          sortable: false,
        },
        {
          label: "Vettore",
          field: "data.vector",
        },
        {
          label: "Visibile",
          field: "data.visible",
          sortable: false,
        },
        {
          label: "Formula",
          field: "data.formula",
          sortable: false,
        },
        {
          label: "Misurato",
          field: "data.measured",
          sortable: false,
        },
        {
          label: "Soglia alert (ore)",
          field: "data.alert_threshold",
          sortable: false,
        },
        {
          label: "Soglia alert 0 (ore)",
          field: "data.alert_zero_threshold",
          sortable: false,
        },
        {
          label: "",
          field: "actions",
          sortable: false,
        },
      ],
      rows: [],
      isDeleteModal: false,
      channelToDelete: {},
      measureTypesList: [],
      msg: "",
      bulkChannels: [],
      bulk: {
        visible: false,
        measured: false,
      },
      measureTypeOperationList: [
        { label: "Crea", value: "ADD" },
        { label: "Modifica", value: "REPLACE" },
      ],
      dataModelToCopyIn: null,
      channelToSwitchSiteAndDatamodel: {},
      modelOptionsFiltered: [],
      sitesList: [],
      siteToCopyIn: null,
      allModelOptions: [],
      allChannels: [],
      parameter: {},
      parametersTree: [],
      isVirtualCopied: false,
    };
  },
  computed: {
    isDemo() {
      return this.$store.state.user && this.$store.state.user.altCustomerName;
    },
    states() {
      return this.$store.state.utils.states;
    },
    towns() {
      return this.$store.state.utils.towns;
    },
    composeAddress() {
      let address = [];

      if (!this.form.addressState && !this.form.addressTown) return "";

      if (this.form.addressStreetName) address.push(this.form.addressStreetName);
      if (this.form.addressStreetNumber) address.push(this.form.addressStreetNumber);
      if (this.form.addressTown) address.push(this.form.addressTown);
      if (this.form.addressState) address.push("(" + this.form.addressState + ")");
      if (this.form.addressZip) address.push(this.form.addressZip);
      if (this.form.addressCountry) address.push(this.form.addressCountry);
      return address.join(", ");
    },
    vectorOptions() {
      let vectors = _.cloneDeep(this.$store.state.vectors.list);

      vectors.unshift({ name: "", id: null });
      return vectors.map((v) => {
        return { text: v.name, value: v.code };
      });
    },
    indicatorsOptions() {
      return this.indicatorFormulas.map((v) => {
        return { text: v.name, value: v.id };
      });
    },
    user() {
      return this.$store.state.user;
    },
    isSuperAdmin() {
      return this.user.level == 1;
    },
    customerName() {
      return this.$store.state.user.altCustomerName
        ? this.$store.state.user.altCustomerName
        : this.$store.state.user.customerName;
    },
    siteName() {
      return this.$store.state.user.altCustomerName ? "####" : this.form.name;
    },
    rootChannelOptions() {
      let array = [];

      let channels = [...this.form.channels];

      channels = channels.filter((item) => {
        if (item.data_model_id != this.currentDataModelId) {
          return false;
        }

        if (this.channel.vector && this.channel.vector != item.vector) {
          return false;
        }

        return true;
      });

      channels = channels.sort((a, b) => {
        if (!a.name) {
          return -1;
        }
        if (!b.name) {
          return 1;
        }
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
      });

      channels.forEach((item) => {
        if (item.is_root) {
          array.push(item);
        }
      });

      if (this.channel.parent_code && this.channel.parent_code != null) {
        channels.forEach((item) => {
          if (!array.includes(item)) {
            if (item.code == this.channel.parent_code) {
              array.push(item);
            }
          }
        });
      }

      channels.forEach((item) => {
        if (!array.includes(item)) {
          array.push(item);
        }
      });

      return array;
    },
  },
  methods: {
    reloadTree() {
      this.$store.commit("loading");

      this.$store.dispatch("sites/get", this.$route.params.guid).then((data) => {
        this.$store.state.sites.current = data;
        this.form.channels = data.channels;
        setTimeout(this.drawTree, 500);
      });

      this.$store.commit("stopLoading");
    },
    formulaSymbol(formula) {
      if (!formula) {
        return;
      }

      if (formula == "children-sum") {
        return " (Σ)";
      }

      if (formula == "parent-minus-siblings") {
        return " (Δ)";
      }

      if (formula == "custom") {
        return " (ƒ)";
      }
    },
    async createParametersTree() {
      this.parametersTree = [];
      let parameters = [];
      this.$store.commit("loading");
      const loadedParameters = await this.$store.dispatch("sites/listParameters", this.guid);
      const parametersList = Array.isArray(loadedParameters) ? loadedParameters : [];
      this.form.parameters = parametersList;

      // get all ancestors
      parametersList.forEach((item) => {
        if (!item.parent_code || item.parent_code == "") {
          parameters.push(item);
        }
      });

      this.parametersTree = [...parameters.map((p) => this.childrenParameter(p, parametersList))];

      this.$store.commit("stopLoading");
    },
    childrenParameter(parameter, all) {
      if (!parameter.code) {
        return { ...parameter };
      }

      parameter.children = all.filter((c) => c.parent_code === parameter.code);
      parameter.children.forEach((c) => this.childrenParameter(c, all));

      return parameter;
    },
    openEditParameterModal(parameter) {
      this.parameter = {};

      if (parameter) {
        this.parameter = { ...parameter };
      }

      this.$bvModal.show("modalEditParameter");
    },
    filterModelOptions(guid) {
      if (!guid) {
        guid = this.guid;
      }

      this.modelOptionsFiltered = this.allModelOptions.filter((item) => {
        if (item.sites.find((site) => site.guid == guid)) {
          return true;
        }
        return false;
      });
    },
    isSiteAvailable(option) {
      const sites = this.sitesList.filter((item) => item.guid != this.form.guid);

      if (sites.find((item) => item.guid == option.guid)) {
        return true;
      }
      return false;
    },
    isDatamodelAvailable(option) {
      let channelsWithSameSiteGuid = [];

      if (this.siteToCopyIn) {
        channelsWithSameSiteGuid = this.allChannels.filter((item) => item.site_guid == this.siteToCopyIn);
      } else {
        channelsWithSameSiteGuid = this.form.channels;
      }

      const channels = channelsWithSameSiteGuid.filter((item) => item.data_model_id == option.id);

      if (channels.find((item) => item.code == this.channelToSwitchSiteAndDatamodel.code)) {
        return false;
      }
      return true;
    },
    switchSiteAndDataModel() {
      this.$store.commit("loading");

      const data = {
        site_guid: this.siteToCopyIn,
        data_model_id: this.dataModelToCopyIn,
      };

      this.$store
        .dispatch("sites/switchSiteAndDataModel", {
          siteId: this.$route.params.guid,
          channelId: this.channelToSwitchSiteAndDatamodel.channel_id,
          data,
        })
        .then((response) => {
          if (response.code == 1) {
            this.$notify({
              type: "success",
              text: "Canale spostato con successo",
              title: "Successo",
            });

            this.load();
            this.$bvModal.hide("modalSwitchSiteAndDatamodel");
          } else {
            this.$notify({
              type: "error",
              text: response.message,
              title: "Errore",
            });
          }
        });

      this.siteToCopyIn = null;
      this.dataModelToCopyIn = null;

      this.$store.commit("stopLoading");
    },
    openSwitchSiteAndDatamodelModal(data) {
      this.channelToSwitchSiteAndDatamodel = data.data;
      this.sitesList = this.$store.state.user.sites;
      this.filterModelOptions(this.guid);
      this.allChannels = [];
      this.$store.state.user.sites.forEach((site) => {
        site.channels.forEach((channel) => {
          this.allChannels.push(channel);
        });
      });
      this.$refs.modalSwitchSiteAndDatamodel.show();
    },
    load() {
      this.customerGuid = this.$store.state.user.customerGuid;
      if (this.$route.params.guid) {
        this.guid = this.$route.params.guid;
        this.$store.commit("loading");

        this.$store.dispatch("sites/get", this.$route.params.guid).then((data) => {
          this.siteId = data.id;
          this.$store.commit("stopLoading");
          this.form = _.cloneDeep(data);

          this.ignoreExternalFields = data.ignoreExternalFields ? data.ignoreExternalFields.join("\n") : "";
          this.$store.dispatch("utils/towns", this.form.addressState);
          if (this.form.latitude && this.form.longitude) {
            this.addMarker(this.form.latitude, this.form.longitude);
          }

          this.$store.dispatch("sites/dataModels", this.customerGuid).then((models) => {
            if (Array.isArray(models)) {
              this.allModelOptions = models;
              this.modelOptions = models.filter((item) => {
                if (item.sites.length > 0) {
                  return !!item.sites.find((site) => site.id == this.siteId);
                }
              });
            }
            if (this.modelOptions.length > 0) {
              this.currentDataModelId = this.modelOptions[0].id;
            }
            if (this.modelOptions.length < 1) {
              this.$refs.modalDataModel.show();
            }
          });

          this.drawTree();
        });
      }

      this.$store.dispatch("utils/states");

      this.$store.dispatch("sites/userTags").then((tags) => {
        this.siteTags = tags.map((t) => t);
      });

      this.$store.dispatch("indicators/formulas").then((formulas) => {
        this.indicatorFormulas = formulas.map((t) => t);
      });
    },
    selectedRowsChange(data) {
      this.bulkChannels = [];
      if (data && data.selectedRows) {
        data.selectedRows.forEach((item) => {
          this.bulkChannels.push(item.data);
        });
      }
    },
    openEditModal(channel) {
      this.channel = { ...channel.data };
      this.channel.id = channel.data.channel_id;
      this.channel.name = channel.data.label;
      this.parent_code = channel.data.parent_code;
      this.$refs.modalEditChannel.show();
    },
    openDeleteModal(channel) {
      this.channelToDelete = channel.data;
      this.$refs.modalDeleteChannel.show();
    },
    customizeFormula(channel) {
      if (channel.data.formula == "children-sum") {
        return "Somma canali figli";
      }
      if (channel.data.formula == "parent-minus-siblings") {
        return "Differenza padre-fratelli";
      }
      if (channel.data.formula == "custom") {
        return "Formula custom";
      }
      return "";
    },
    customizeVector(channel) {
      const vector = this.vectorOptions.find((item) => item.value == channel.data.vector);
      return vector.text;
    },
    customizeDataModel(channel) {
      const datamodel = this.modelOptions.find((item) => item.id == channel.data.data_model_id);
      if (!datamodel) return "";

      return datamodel.name;
    },
    preventSubmit(e, type) {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        return;
      }

      let error = 0;

      if (this.channel.formula == "parent-minus-siblings") {
        this.form.channels.forEach((item) => {
          if (
            item.parent_code == this.parent_code &&
            item.formula == this.channel.formula &&
            item.code != this.channel.code &&
            item.data_model_id == this.currentDataModelId
          ) {
            error++;
            return;
          }
        });

        if (error > 0) {
          this.$notify({
            type: "error",
            text: "Esiste già un canale 'differenza padre-figlio' in questo livello",
            title: "Errore",
          });
          return;
        }
      }

      if (this.channel.formula == "custom") {
        if (!this.channel.custom_formula) {
          this.$notify({
            type: "error",
            text: "Inserire la formula custom",
            title: "Errore",
          });
          return;
        }

        const matches = this.channel.custom_formula.match(/\{(.+?)\}/g);

        if (matches) {
          matches.forEach((ele) => {
            const match = ele.replace(/\{?\}?/g, "").trim();

            if (!this.form.channels.find((ch) => ch.code == match && ch.data_model_id == this.currentDataModelId)) {
              error++;
            }
          });
        }

        if (error > 0) {
          this.$notify({
            type: "error",
            text: "La formula custom contiene codici canale sconosciuti",
            title: "Errore",
          });
          return;
        }
      }

      this.editChannel(e, type);
    },
    resetChannel() {
      this.copyFromChannel = "";
      this.channel = {
        visible: 1,
      };
      this.parent_code = null;
    },
    drawTree() {
      this.cy.destroy();
      this.initChannels();

      this.rows = [];
      let excluded_codes = [];
      this.searchChannelOptions = [];
      if (this.form.channels.length) {
        this.form.channels.forEach((channel, index) => {
          if (channel.data_model_id !== this.currentDataModelId) {
            return;
          }
          if (!!this.selectedVector && channel.vector !== this.selectedVector) {
            excluded_codes.push(channel.code);
            return;
          }

          this.searchChannelOptions.push({ label: channel.name, code: channel.code });

          let data = {
            id: channel.code,
            channel_id: channel.id,
            code: channel.code,
            label: channel.name,
            visible: channel.visible,
            is_root: channel.is_root,
            is_supply: channel.is_supply,
            is_self_production: channel.is_self_production,
            category: channel.category,
            vector: channel.vector,
            formula: channel.formula,
            custom_formula: channel.custom_formula,
            external_codes: channel.external_codes,
            external_codes_string: channel.external_codes ? channel.external_codes.join("\n") : {},
            depth: channel.depth,
            parent_code: !excluded_codes.includes(channel.parent_code) ? channel.parent_code : null,
            data_model_id: channel.data_model_id,
            measured: channel.measured,
            alert_threshold: channel.alert_threshold,
            alert_zero_threshold: channel.alert_zero_threshold,
            is_realtime: channel.is_realtime,
            min_sampling: channel.min_sampling,
            measure_types: channel.measure_types,
            is_virtual: channel.is_virtual,
            virtual_value: parseFloat(channel.virtual_value),
            root_channel_code: channel.root_channel_code,
          };
          this.cy.add({ data });
          this.rows.push({ data });

          this.addChannelEvent(data);
          this.channelsOptions.push({ text: channel.name, value: channel.code });
        });
        this.channelsOptions = this.channelsOptions.sort((a, b) => {
          if (!a.text) {
            return -1;
          }
          if (!b.text) {
            return 1;
          }
          return a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1;
        });

        this.searchChannelOptions = this.searchChannelOptions.sort((a, b) => {
          if (!a.label) {
            return -1;
          }
          if (!b.label) {
            return 1;
          }
          return a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1;
        });
        this.updateChannelsFromChart();
      }
    },
    async editChannel(evt, editOrAdd) {
      //try {
      evt.preventDefault();
      this.channelMessageShow = false;
      this.isVirtualCopied = false;

      let isEdit = this.channel.id != undefined;

      this.editChannelOk = isEdit ? "Modifica" : "Aggiungi";
      this.editChannelTitle = isEdit ? "Modifica canale" : "Nuovo canale";

      this.channel.site_guid = this.guid;
      this.channel.data_model_id = this.currentDataModelId;
      this.channel.parent_code = this.parent_code;

      if (this.channel.is_virtual == 1) {
        this.channel.virtual_value = this.channel.virtual_value ? parseFloat(this.channel.virtual_value) : null;
        this.channel.formula = null;
        this.channel.custom_formula = null;
      } else {
        this.channel.virtual_value = null;
      }

      let channelWithSameCode = false;

      this.$store.state.user.sites.forEach((item) => {
        if (item.channels.find((ch) => ch.code == this.channel.code && ch.data_model_id == this.currentDataModelId)) {
          channelWithSameCode = true;
        }
      });

      if (this.channel.code) {
        const channelWithDifferentDataModel = this.form.channels.find(
          (item) => item.code == this.channel.code && item.data_model_id != this.channel.data_model_id
        );

        if (channelWithDifferentDataModel && channelWithDifferentDataModel.is_virtual == 1) {
          this.channel.is_virtual = channelWithDifferentDataModel.is_virtual;
          this.channel.virtual_value = channelWithDifferentDataModel.virtual_value;

          const rootChannel = this.form.channels.find(
            (item) =>
              item.code == channelWithDifferentDataModel.root_channel_code &&
              item.data_model_id == this.channel.data_model_id
          );

          if (rootChannel && rootChannel.code) {
            this.channel.root_channel_code = channelWithDifferentDataModel.root_channel_code;
          }

          this.isVirtualCopied = true;
        }
      }

      if (editOrAdd == "add") {
        if (this.channel.code && channelWithSameCode) {
          this.channelMessage = "Codice canale già in uso";
          this.channelAlertVariant = "danger";
          this.channelMessageShow = true;
          return;
        }
        this.form.channels.push(this.channel);
        this.msg = "Canale creato";
      } else {
        this.form.channels = this.form.channels.map((item) => {
          if (item.id == this.channel.id) {
            return this.channel;
          }
          return item;
        });
        this.msg = "Canale modificato";
      }

      await this.saveChannel();

      try {
      } catch (e) {
        console.log(e);
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
    async deleteChannel() {
      let error = 0;
      let channelFormulaCustom = {};

      for (let i = 0; i < this.form.channels.length; i++) {
        if (
          this.form.channels[i].custom_formula &&
          this.form.channels[1].data_model_id == this.channelToDelete.data_model_id &&
          error < 1
        ) {
          const matches = this.form.channels[i].custom_formula.match(/\{(.+?)\}/g);

          if (matches) {
            matches.forEach((ele) => {
              const match = ele.replace(/\{?\}?/g, "").trim();

              if (match == this.channelToDelete.code) {
                error++;
                channelFormulaCustom = this.form.channels[i];
              }
            });
          }
        }
      }

      if (error > 0) {
        this.$notify({
          type: "error",
          text:
            'Impossibile eliminare il canale in quanto presente nella formula di "' + channelFormulaCustom.name + '"',
          title: "Errore",
        });
        return;
      }

      this.form.channels = this.form.channels.filter((c) => c.id != this.channelToDelete.id);

      this.form.channels = this.form.channels.map((c) => {
        if (c.parent_code == this.channelToDelete.code && c.data_model_id == this.currentDataModelId) {
          c.parent_code = this.channelToDelete.parent_code;
          c.depth = 0;
        }
        return c;
      });

      this.$refs.modalEditChannel.hide();
      this.$bvModal.hide("modalAddChannel");

      this.$store.dispatch("sites/deleteChannel", this.channelToDelete.channel_id).then(() => {
        this.$notify({
          type: "success",
          text: "Canale eliminato",
          title: "Successo",
        });
        this.$store.dispatch("sites/get", this.$route.params.guid).then((data) => {
          this.$store.state.sites.current = data;
          this.form.channels = data.channels;
          setTimeout(this.drawTree, 100);
        });
      });
    },
    zoom() {
      if (!this.selectedChannel) {
        this.resetZoom();
        return;
      }
      this.cy.animate(
        {
          zoom: 1.5,
          center: {
            eles: this.cy.getElementById(this.selectedChannel.code),
          },
        },
        { duration: 500 }
      );
    },
    resetZoom() {
      this.cy.fit();
      this.selectedChannel = null;
    },
    updateCoordinates(coo) {
      this.form.latitude = coo.lat;
      this.form.longitude = coo.lng;
    },
    print() {},
    expand() {
      this.cyState = "expanded";
      setTimeout(() => {
        this.cy.resize();
        this.cy.fit();
      }, 100);
    },
    compress() {
      this.cyState = "";
      setTimeout(() => {
        this.cy.resize();
        this.cy.fit();
      }, 100);
    },
    addChannelEvent(data) {
      this.cy.$id(data.id).on("tap", (evt) => {
        var node = evt.target;
        this.openEditModal({ data: data });

        setTimeout(() => {
          this.channel.id = node.data("channel_id");
          this.channel.name = node.data("label");
          this.channel.formula = node.data("formula");
          this.channel.custom_formula = node.data("custom_formula");
          this.channel.vector = node.data("vector");
          this.channel.visible = node.data("visible");
          this.channel.is_root = node.data("is_root");
          this.channel.is_supply = node.data("is_supply");
          this.channel.is_self_production = node.data("is_self_production");
          this.channel.parent_code = node.data("parent_code");
          this.parent_code = node.data("parent_code");
          this.channel.code = node.data("code");
          this.channel.external_codes = node.data("external_codes");
          this.channel.external_codes_string = Array.isArray(this.channel.external_codes)
            ? this.channel.external_codes.join("\n")
            : "";
          this.channel.category = node.data("category");
          this.channel.measured = node.data("measured");
          this.channel.alert_threshold = node.data("alert_threshold");
          this.channel.alert_zero_threshold = node.data("alert_zero_threshold");
          this.channel.is_realtime = node.data("is_realtime");
          this.channel.min_sampling = node.data("min_sampling");
          this.channel.measure_types = node.data("measure_types");
          this.$forceUpdate();
        }, 0);
      });
    },
    initChannels() {
      this.cy = cytoscape({
        container: this.$refs.cy,
        elements: [],
        style: [
          // the stylesheet for the graph
          {
            selector: "node",
            style: {
              "background-color": (ele) => {
                if (ele.data("vector") === "EE") return "#8BDF75";

                if (ele.data("vector") === "gas") return "#EBE137";

                return "#f0f0f0";
              },
              "border-color": (ele) => {
                if (ele.data("vector") === "EE") return "#52AC3A";

                if (ele.data("vector") === "gas") return "#AAA21F";

                return "#666";
              },
              "border-width": "4px",
              "text-wrap": "wrap",
              label: (ele) => {
                var label = ele.data("label");

                if (ele.data("formula")) {
                  label += this.formulaSymbol(ele.data("formula"));
                }

                if (ele.data("is_root") == 1) {
                  label += " ■";
                }

                if (ele.data("is_virtual") == 1) {
                  label += " *";
                }

                var code = ele.data("code");
                return label + "\n" + code;
              },
              "text-halign": "center",
              "text-valign": "center",
              "text-background-color": (ele) => {
                if (ele.data("category") == 1) return "#4499ac";

                if (ele.data("category") == 2) return "#dd514e";

                if (ele.data("category") == 3) return "#898989";

                return "#f0f0f0";
              },
              "text-border-color": "#666",
              color: (ele) => {
                if (ele.data("category") == 4) return "#000";

                if (ele.data("category") > 0) return "#fff";

                return ele.data("visible") == 1 ? "#333" : "#000";
              },
              "text-border-width": "2px",
              "text-background-opacity": 1,
              "text-background-shape": "roundrectangle",
              "text-background-padding": 4,
              "text-border-opacity": 1,
              width: 80,
              height: 80,
              opacity: (ele) => {
                return ele.data("visible") == 1 ? 1 : 0.65;
              },
            },
          },

          {
            selector: "edge",
            style: {
              width: 3,
              "line-color": "#cccccc",
              "target-arrow-color": "#cccccc",
              "target-arrow-shape": "triangle",
            },
          },
        ],
        boxSelectionEnabled: false,
        autounselectify: true,
        autoungrabify: true,
        userZoomingEnabled: true,
        layout: {
          name: "dagre",
        },
      });
    },
    updateChannelsFromChart() {
      this.cy.elements().forEach((ele) => {
        if (ele.isEdge()) ele.remove();
      });

      this.channelsOptions = [];
      let rootNode = null;
      this.cy.elements().forEach((node) => {
        this.channelsOptions.push({ text: node.data("label"), value: node.data("code") });

        if (node.data("parent_code")) {
          let edgeId = ("ch" + Math.random()).replace(/\./, "");
          this.cy.add({
            data: { id: edgeId, source: node.data("parent_code"), target: node.data("code") },
          });
        } else {
          node.data("depth", 0);
          rootNode = node;
        }
      });
      this.channelsOptions = this.channelsOptions.sort((a, b) => {
        if (!a.text) {
          return -1;
        }
        if (!b.text) {
          return 1;
        }
        return a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1;
      });

      if (rootNode) {
        this.cy.elements().dfs({
          roots: "#" + rootNode.data("id"),
          visit: function (v, e, u, i, depth) {
            v.data("depth", depth);
          },
          directed: false,
        });

        var layout = this.cy.makeLayout({ name: "dagre" });
        layout.options.eles = this.cy.elements();
        layout.run();
      }
    },
    cancelEditing() {
      this.$router.push("/sites");
    },
    loadTowns() {
      this.$store.dispatch("utils/towns", this.form.addressState);
    },
    setPlace(place) {
      let country = place.address_components.filter((address_component) =>
        ["country"].some((word) => ~address_component.types.indexOf(word))
      );
      let state = place.address_components.filter((address_component) =>
        ["administrative_area_level_2"].some((word) => ~address_component.types.indexOf(word))
      );
      let city = place.address_components.filter((address_component) =>
        ["administrative_area_level_3"].some((word) => ~address_component.types.indexOf(word))
      );
      let zip = place.address_components.filter((address_component) =>
        ["postal_code"].some((word) => ~address_component.types.indexOf(word))
      );
      let streetNumber = place.address_components.filter((address_component) =>
        ["street_number"].some((word) => ~address_component.types.indexOf(word))
      );
      let streetName = place.address_components.filter((address_component) =>
        ["route"].some((word) => ~address_component.types.indexOf(word))
      );

      this.form.addressCountry =
        country.length > 0 && country[0].short_name !== "undefined" ? country[0].short_name : null;
      this.form.addressState = state.length > 0 && state[0].short_name !== "undefined" ? state[0].short_name : null;
      this.form.addressTown = city.length > 0 && city[0].short_name !== "undefined" ? city[0].short_name : null;
      this.form.addressZip = zip.length > 0 && zip[0].short_name !== "undefined" ? zip[0].short_name : null;
      this.form.addressStreetNumber =
        streetNumber.length > 0 && streetNumber[0].short_name !== "undefined" ? streetNumber[0].short_name : null;
      this.form.addressStreetName =
        streetName.length > 0 && streetName[0].short_name !== "undefined" ? streetName[0].short_name : null;

      this.form.longitude = place.geometry.location.lng();
      this.form.latitude = place.geometry.location.lat();

      this.loadTowns();
      this.currentPlace = place;
    },
    goDelete() {
      this.$store.dispatch("sites/delete", this.form.guid).then(() => {
        this.$notify({
          type: "success",
          text: "Sito eliminato",
          title: "Successo",
        });
        this.$router.push("/sites");
      });
    },
    addMarker(lat, lng) {
      let marker = {};
      if (this.currentPlace) {
        lat = this.currentPlace.geometry.location.lat();
        lng = this.currentPlace.geometry.location.lng();
      }

      if (lat && lng) {
        marker = { lat, lng };
        this.form.latitude = marker.lat;
        this.form.longitude = marker.lng;
        this.marker = { position: marker };
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    openConversionModal(idx) {
      this.currentParameter = idx;
      this.conversions = this.form.parameters[idx].conversions;
      if (this.conversions.length == 0) this.conversions.push({});
      this.$refs.modalConversion.show();
    },
    closeConversionModal() {
      this.form.parameters[this.currentParameter].conversions = _.clone(this.conversions);
    },
    removeConversion(idx) {
      this.conversions.splice(idx, 1);
    },
    removeCost(idx) {
      this.form.vectorCosts.splice(idx, 1);
    },
    addIndicator() {
      this.form.indicators.push({});
    },
    addVectorCost() {
      if (this.form.vectorCosts.length && this.form.vectorCosts.find((v) => !(v.vector && v.cost))) {
        this.$notify({
          type: "success",
          text: "Costi incompleti",
          title: "Successo",
        });
      } else {
        this.form.vectorCosts.push({});
      }
    },
    removeSiteMarker(idx) {
      this.form.parameters.splice(idx, 1);
    },
    removeIndicator(idx) {
      this.form.indicators.splice(idx, 1);
    },
    addSiteParameter() {
      this.parameter = {};
      this.$bvModal.show("modalEditParameter");
    },
    openBulkModal() {
      if (this.bulkChannels.length < 1) {
        this.$notify({
          type: "warn",
          text: "Selezionare almeno un canale",
          title: "Attenzione",
        });
        return;
      }
      this.$nextTick(() => {
        this.bulk.visible = null;
        this.$bvModal.show("modalBulkChannel");
      });
    },
    closeBulkModal() {
      this.bulk = {};
      this.$nextTick(() => {
        this.$bvModal.hide("modalBulkChannel");
      });
    },
    async submitBulk() {
      try {
        if (
          !this.bulk.type_operation &&
          this.bulk.measure_types &&
          this.bulk.measure_types.length > 0 &&
          !this.bulk.data_model_id &&
          !this.bulk.parent_code
        ) {
          this.$notify({
            type: "error",
            text: "Selezionare l'operazione da effettuare",
            title: "Errore",
          });
          return;
        }
        this.$store.commit("loading");
        let bulkChannel = {};
        bulkChannel.siteGuid = this.$route.params.guid;
        bulkChannel.channelIds = this.bulkChannels.map((item) => item.channel_id);
        bulkChannel.channelCodes = this.bulkChannels.map((item) => item.code);
        bulkChannel.minSampling = this.bulk.min_sampling;
        bulkChannel.measureTypes = this.bulk.measure_types;
        bulkChannel.vector = this.bulk.vector;
        bulkChannel.visible = this.bulk.visible;
        bulkChannel.measured = this.bulk.measured;
        bulkChannel.alertThreshold = this.bulk.alert_threshold;
        bulkChannel.measureTypeOperation = this.bulk.type_operation;
        bulkChannel.dataModelId = this.bulk.data_model_id;
        bulkChannel.parentCode = this.bulk.parent_code ? this.bulk.parent_code.code : null;

        const response = await this.$store.dispatch("sites/bulkOperations", bulkChannel);
        if (response.code != 1) {
          this.$notify({
            type: "error",
            text: response.message,
            title: "Errore",
          });
          this.$store.commit("stopLoading");
          return;
        } else {
          this.$notify({
            type: "success",
            text: "Canali modificati correttamente",
            title: "Successo",
          });
          this.$nextTick(() => {
            this.$bvModal.hide("modalBulkChannel");
          });
          this.bulk = {
            visible: false,
            measured: false,
          };
        }
        this.$store.commit("stopLoading");
        this.$store.dispatch("sites/get", this.$route.params.guid).then((data) => {
          if (data) {
            this.form.channels = data.channels;
          }
          this.drawTree();
        });
      } catch (e) {
        console.log(e);
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
        this.$store.commit("stopLoading");
      }
    },
    handleSubmit() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        this.$notify({
          type: "error",
          text: "Compilare i campi obbligatori",
          title: "Errore",
        });
        return;
      }
      this.submit();
    },
    async saveChannel() {
      try {
        let channel = {
          ...this.channel,
        };

        if (!channel.external_codes_string) {
          channel.external_codes_string = "";
        }

        channel.external_codes = [
          ...new Set(channel.external_codes_string.split("\n").filter((code) => code.length > 0)),
        ];

        const site_guid = this.form.guid;
        var storeData = {
          site_guid,
          channel,
        };

        this.$store.commit("loading");
        await this.$store.dispatch("sites/storeChannel", storeData).then((response) => {
          if (response.code != 1) {
            this.$notify({
              type: "error",
              text: response.message,
              title: "Errore",
            });
            this.$store.commit("stopLoading");
            return;
          } else {
            this.$notify({
              type: "success",
              text: "Canali salvati correttamente",
              title: "Successo",
            });

            if (this.isVirtualCopied) {
              this.$notify({
                type: "success",
                text: "Sono state applicate le impostazioni dell'utenza",
                title: "Successo",
              });
            }

            this.$store.dispatch("sites/get", this.$route.params.guid).then((data) => {
              this.$store.state.sites.current = data;
              this.form.channels = data.channels;
              setTimeout(this.drawTree, 200);
            });

            this.channel = {
              visible: 1,
            };
            this.parent_code = null;

            this.$nextTick(() => {
              this.$bvModal.hide("modalAddChannel");
              this.$bvModal.hide("modalEditChannel");
            });

            this.$store.commit("stopLoading");
          }
        });
      } catch (e) {
        console.log(e);
        this.$notify({
          type: "error",
          text: e.message,
          title: "Errore",
        });
      }
    },
    async submit() {
      this.$store.commit("loading");

      var site_guid = this.$route.params.guid ? this.$route.params.guid : 0;

      this.form.customerGuid = this.$store.state.customers.selected.guid;

      let saveObj = _.cloneDeep(this.form);
      saveObj.ignoreExternalFields = this.ignoreExternalFields.split("\n");
      saveObj.parameters.map((item) => {
        item.siteGuid = site_guid;
        return item;
      });

      saveObj.ignoreExternalFields = saveObj.ignoreExternalFields.filter(function (item) {
        return item.trim().length > 0;
      });

      //indicators check
      for (let i = 0; i < this.form.indicators.length; i++) {
        if (
          !this.form.indicators[i].formulaId ||
          !this.form.indicators[i].numerator ||
          !this.form.indicators[i].denominator
        ) {
          this.$store.commit("stopLoading");
          this.$notify({
            type: "error",
            text: "Compilare i campi obbligatori degli indicatori",
            title: "Errore",
          });
          return;
        }
      }

      //parameters check
      for (let i = 0; i < this.form.parameters.length; i++) {
        console.log(this.form.parameters);
        if (
          !this.form.parameters[i].parameter ||
          !this.form.parameters[i].name ||
          !this.form.parameters[i].code ||
          !this.form.parameters[i].mu ||
          !this.form.parameters[i].grouping ||
          !this.form.parameters[i].min_sampling
        ) {
          this.$store.commit("stopLoading");
          this.$notify({
            type: "error",
            text: "Compilare i campi obbligatori dei parametri",
            title: "Errore",
          });
          return;
        }
      }

      await this.$store.dispatch("sites/edit", { data: saveObj, guid: site_guid }).then((data) => {
        this.$store.commit("stopLoading");

        this.$notify({
          type: "success",
          text: "Dati salvati",
          title: "Successo",
        });
        this.$store.dispatch("loadUser");
      });

      if (this.cy.elements().length == 0) this.$router.push("/sites");
    },
    lineeFilter(option, label, search) {
      if (search) {
        let temp = search.toLowerCase();
        let name = option.label || "";
        let code = option.code || "";

        return name.toLowerCase().indexOf(temp) > -1 || code.toLowerCase().indexOf(temp) > -1;
      }
    },
    addNewChannel() {
      this.channel = { visible: 1 };
      this.parent_code = null;
    },
  },
  watch: {
    currentDataModelId() {
      this.selectedChannel = null;
      this.selectedVector = null;
      this.drawTree();
    },
    copyFromModel() {
      this.copyChannelOptions = this.form.channels
        .filter((item) => item.data_model_id == this.copyFromModel)
        .map((item) => {
          return { label: item.name, code: item.code };
        });
      this.copyChannelOptions = this.copyChannelOptions.sort((a, b) => {
        return a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1;
      });
      this.drawTree();
    },
    copyFromChannel() {
      this.channel = { ...this.form.channels.find((item) => item.code == this.copyFromChannel.code) };
      this.channel.id = null;
      this.channel.data_model_id = this.currentDataModelId;
      this.channel.externalCode = "";
      this.channel.external_codes = [];
    },
  },
};
</script>

<style scoped>
.parameters-list {
  max-height: 50vh;
  overflow: auto;
}

.update-icon {
  align-self: center;
  cursor: pointer;
}

.parameter-cnt {
  font-size: 12px;
  margin-bottom: 0.25rem;
  background: #f0f0f0;
  display: flex;
  justify-content: space-between;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 10px 12px;
  white-space: nowrap;
  max-width: 400px;
}

.parameter-info {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 350px;
}

.parameter-badge {
  background: #fff;
  color: #000;
  padding: 1px 4px;
  border-radius: 5px;
}

.code {
  background: #666;
  color: #fff;
  margin: 0 5px;
}

.mu {
  background: #b3b3b3;
  color: #fff;
}

.param-input {
  font-size: 12px;
  padding: 5px;
}

.expanded .filters {
  position: fixed;
  z-index: 10000;
  top: 20px;
  left: 20px;
}

.change-button {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #b1bdca;
  padding: 5px 7px;
}

.change-button:hover {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #b1bdca;
}

#map {
  width: 100%;
  height: 400px;
  background: #ccc;
  border: 1px solid #aaa;
}

#cy {
  padding: 15px;
  width: 100%;
  height: 400px;
  background: #fafafa;
  border-radius: 6px;
}

textarea {
  height: 100px;
}

#cy a.btn {
  color: #fff;
}

.channel {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;
}

.um-cell {
  max-width: 100px;
}

.val-cell {
  max-width: 120px;
}

.convert {
  position: relative;
}

.convert .badge {
  position: absolute;
  top: -6px;
  right: -9px;
}

.remove-indicator {
  position: relative;
  top: 33px;
}

#expand,
#compress {
  position: absolute;
  top: 50px;
  right: 10px;
  z-index: 100;
  cursor: pointer;
}

.expanded #expand {
  display: none;
}

#compress {
  position: fixed;
  display: none;
  z-index: 202;
}

.top-select {
  width: 275px;
}

.top-select-name {
  width: 350px;
}

.expanded #compress {
  display: block;
  top: 27px;
  right: 20px;
}

.expanded #cy {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto;
  z-index: 201;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Sites/Site.vue